export enum FinancialTransactionType {
    "Investment" = 'investment',
    "Investment Return" = 'investment return',
    "Deposit" = 'deposit',
    "Withdraw" = 'withdraw',
    "Donate" = 'donate',
    "Retention" = "retention"
}
